module.exports = __webpack_public_path__ + "img/CAL-UHF-Zubehörkoffer_transparent_Var2.7b3c079f.webp";